import { Link } from 'react-router-dom';
import { articleCategories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                果冻传媒
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed mt-3">
              专注创意内容生产与品牌传播的专业机构，用创意连接品牌与消费者，让每一次传播都产生价值。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">服务领域</h4>
            <ul className="space-y-2.5">
              {articleCategories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/about#contact" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-sm text-foreground-400 mt-0.5"></i>
                <span className="text-sm text-foreground-300">北京市朝阳区建国路88号SOHO现代城A座</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-sm text-foreground-400"></i>
                <span className="text-sm text-foreground-300">010-8888-6666</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-sm text-foreground-400"></i>
                <span className="text-sm text-foreground-300">hello@guodongmedia.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-400">
            &copy; {new Date().getFullYear()} 果冻传媒 版权所有
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors text-sm cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors text-sm cursor-pointer" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}